"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const UsersMap = () => {
    const getData = async () => {
        const request = await fetch(`https://stats.origyn.ch/api/stats/governance.origyn.network/countries?period=30d&date=2024-05-20&filters=%7B%7D&with_imported=true&auth=W1cZdfB6cnSpcM5_G2FRD&limit=300`, {
            headers: {
                "Authorization": "Bearer 4JLZXlK5E4aez1-wUsTgUnV776jYkjrYBfGT21vzZNGf4Ku58dwRLTAC64ZNtinj",
                // 'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        const response = await request.json();
        const datObj = response.reduce((res, c) => ({
            ...res, [c.alpha_3]: {
                ...c,
                country: c.alpha_3,
                centered: c.alpha_3,
                radius: c.percentage / 10 + 8,
                fillKey: c.percentage > 10 ? 'bubbleBig' : 'bubbleSmall',
            }
        }), {});
        const bubbles = response.map((c) => ({
            ...c,
            country: c.alpha_3,
            centered: c.alpha_3,
            radius: c.percentage + 4,
            fillKey: c.percentage > 10 ? 'bubbleBig' : 'bubbleSmall',
        }));
        //@ts-ignore
        const map1 = new window.Datamap({
            element: document.getElementById('container1'),
            geographyConfig: {
                popupOnHover: true,
                highlightOnHover: true,
                highlightFillColor: "#36454F",
                highlightBorderColor: "#36454F",
                borderColor: "#69737C",
                borderWidth: 0.5,
                popupTemplate: function (geo, data) {
                    return '<div class="hoverinfo">' + data.name + '<br/>' + 'Visitors:' + data.visitors + '</div>';
                },
            },
            bubblesConfig: {
                borderWidth: 0.2,
                highlightFillColor: "#36454F",
                highlightBorderColor: "#36454F",
                borderColor: "#69737C",
            },
            data: datObj,
            fills: {
                defaultFill: "#ffffff",
                bubbleDefault: "#222526",
                bubbleSmall: "#E1E1E1",
                bubbleBig: "#222526",
            }
        });
        //@ts-ignore
        const map = new window.Datamap({
            element: document.getElementById('container'),
            geographyConfig: {
                popupOnHover: true,
                highlightOnHover: false,
                borderColor: '#69737C',
                borderWidth: 0.5,
                popupTemplate: function (geo, data) {
                    return '<div class="hoverinfo">' + data.name + '<br/>' + 'Visitors:' + data.visitors + '</div>';
                },
            },
            bubblesConfig: {
                borderWidth: 0,
                borderColor: '#69737C',
            },
            data: bubbles,
            fills: {
                defaultFill: '#FFFFFF',
                bubbleDefault: '#222526',
                bubbleSmall: '#E1E1E1',
                bubbleBig: '#222526',
            }
        });
        map.bubbles(bubbles, {
            popupTemplate: function (geo, data) {
                return '<div class="hoverinfo">' + data.name + '<br/>' + 'Visitors:' + data.visitors + '</div>';
            },
        });
    };
    (0, react_1.useEffect)(() => {
        getData();
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { id: "container1", style: { position: 'relative', width: '100%', height: '600px' } })));
};
exports.default = UsersMap;
